import { UserActivationStatus, WhiteboardPermission } from "@src/gql/graphql";
import type { Collaborators } from "../board/schema";

import type { z } from "zod";
import type { Role, userSelected } from "./whiteboard-invite-schema";

export function getUserFromCollaborator(
	collaborator: Collaborators[number],
): z.infer<typeof userSelected> {
	const name =
		collaborator.details?.displayName ??
		[collaborator.details?.firstName, collaborator.details?.lastName]
			.filter((n) => !!n)
			.join(" ");

	const email = collaborator.details?.email ?? collaborator?.userEmail ?? "";
	const avatarUrl = collaborator.details?.avatarUrl ?? "";
	const permission = getShareWhiteboardUserStateFromPermission(
		collaborator.permission,
	);

	const activationStatus =
		collaborator.details?.activationStatus ?? UserActivationStatus.Unknown;

	return {
		name,
		email,
		avatarUrl,
		permission,
		activationStatus,
	};
}

export function getShareWhiteboardUserStateFromPermission(
	permission: WhiteboardPermission,
): Role {
	if (permission === WhiteboardPermission.Read) {
		return "Viewer";
	}

	if (permission === WhiteboardPermission.Write) {
		return "Editor";
	}

	return "Owner";
}
